import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function MatchRatio(props) {
  const matchRatio = props.ratio ? props.ratio : 0;
  const width = props.width;
  const mainFontSize = props.mainFontSize;
  const subFontSize = props.subFontSize;

  const colorDiscrimination = (ratio) => {
    if (ratio <= 50) return "#E9E9E9";
    if (ratio <= 60) return "#D2D2D2";
    if (ratio <= 70) return "#BCBCBC";
    if (ratio <= 74) return "#D7D2B8";
    if (ratio <= 75) return "#DDD7B7";
    if (ratio <= 76) return "#E4DCB6";
    if (ratio <= 77) return "#EBE2B5";
    if (ratio <= 78) return "#F1E7B4";
    if (ratio <= 80) return "#FFF2B2";
    if (ratio <= 82) return "#FEEDB3";
    if (ratio <= 83) return "#FEEAB3";
    if (ratio <= 84) return "#FDE7B3";
    if (ratio <= 86) return "#FDE2B4";
    if (ratio <= 87) return "#FDDFB4";
    if (ratio <= 91) return "#FBD3B5";
    if (ratio <= 93) return "#FACCB6";
    if (ratio <= 95) return "#FAC5B6";
    if (ratio <= 97) return "#F9BEB7";
    return "#F8BAB7"; // 98~100
  };

  const bgcolor = colorDiscrimination(matchRatio);

  return (
    <Box sx={{ display: matchRatio ? "block" : "none" }}>
      <Box
        sx={{
          width,
          height: width,
          bgcolor,
          borderRadius: "50%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          align="center"
          sx={{
            fontSize: subFontSize,
            pb: "2px",
          }}
        >
          マッチ率
        </Typography>

        <Box sx={{ height: mainFontSize }}>
          <Typography
            sx={{
              fontSize: mainFontSize,
              height: mainFontSize,
              lineHeight: mainFontSize,
              fontWeight: "bold",
              display: "inline",
              letterSpacing: "-0.05em",
            }}
            align="right"
          >
            {Math.round(Number(matchRatio))}
          </Typography>
          <Typography
            sx={{ display: "inline", fontSize: subFontSize }}
            align="left"
          >
            %
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
